import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: yangfan
 * @Date: 2022-01-21 17:11:15
 * @LastEditTime: 2022-01-21 17:11:15
 * @LastEditors: yangfan
 * @Description: 被保人列表
 */
import React, { useEffect, useState, useContext } from 'react';
import { Modal } from 'zarm';
import { FormContext } from '@/store/context';
import { dispatch, getFormValue, setFormValue } from '@/store';
import { PLAN_ID } from '@/constants';
import Iconfont from '../Iconfont'; // import { AddableBlock, DeletableBlock } from '../common';

import InsuredItem from '../InsuredItem';
import './index.less';

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = Math.random() * 16 | 0; // eslint-disable-next-line no-bitwise

    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

const delUndefineValue = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

const InsuredWithPlanSelect = (props = {}) => {
  var _getFormValue;

  const {
    attrs,
    children,
    form,
    Render,
    content = '是否确认删除？'
  } = props;
  const sessionInsuredLength = (_getFormValue = getFormValue('insured')) === null || _getFormValue === void 0 ? void 0 : _getFormValue.length; // const { setInsuredLen } = useContext(FormContext);

  const {
    prefix = '被保人',
    buttonText = '添加被保人',
    relationFieldKey = 'holderRelation',
    minInsuredCount = 1,
    maxInsuredCount = 1,
    type,
    factors = []
  } = attrs;
  const defaultInsuredCount = sessionInsuredLength || attrs.defaultInsuredCount || 1;
  const [insuredList, setInsuredList] = useState([]);
  useEffect(() => {
    const insured = getFormValue('insured') || [];
    const trailElement = getFormValue('trailElement');
    const insuredTrail = (trailElement === null || trailElement === void 0 ? void 0 : trailElement[1]) || [];
    const mapArr = insured.length > insuredTrail.length ? insured : insuredTrail;
    const insuredNext = mapArr.map((i, index) => {
      const item1 = insuredTrail[index] || {};
      let item2 = insured[index] || {};
      item2 = delUndefineValue(item2);
      return _objectSpread(_objectSpread({}, item1), item2);
    }).filter(item => item.status === 'finish');
    setInsuredList(insuredNext);
    setFormValue({
      insured: insuredNext
    });
    dispatch({
      maxInsurant: maxInsuredCount,
      minInsurant: minInsuredCount
    });
  }, []); // 清除外层  planId

  useEffect(() => {
    dispatch(PLAN_ID, undefined);
  }, {}); // 添加被保人

  const onAddInsuredItem = () => {
    const list = getFormValue('insured') || []; // 若为首个被保人自动设置为本人，带出投保人信息

    list.push(_objectSpread({
      customId: guid(),
      mode: 'add'
    }, list.length ? {} : {
      holderRelation: 'self'
    }));
    setInsuredList([...list]);
    setFormValue({
      insured: [...list]
    });
  }; // 处理投保流程配置通知


  const handleFlowConfigMessage = ({
    data
  }) => {
    if ((data === null || data === void 0 ? void 0 : data.data) === 'ADD_INSURED') {
      setInsuredList([{
        mode: 'add'
      }]); // 切换到被保人列表/其他模块
    } else if ((data === null || data === void 0 ? void 0 : data.data) === 'DELETE_INSURED' || (data === null || data === void 0 ? void 0 : data.type) === 'activeModuleId') {
      setInsuredList([]);
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleFlowConfigMessage, true);
    return () => {
      window.removeEventListener('message', handleFlowConfigMessage);
    };
  }, []); // 删除被保人

  const onDeleteInsuredItem = (customId, isConfirm = true) => {
    const result = insuredList.filter(e => e.customId !== customId);

    const onSuccess = () => {
      setInsuredList(result);
      setFormValue({
        insured: [...result]
      });
    }; // 取消


    if (!isConfirm) {
      return onSuccess();
    } // 删除


    Modal.confirm({
      title: '操作确认',
      content,
      onOk: onSuccess
    });
  }; // 保存被保人信息


  const onSaveInsuredItem = () => {
    const insuredResult = getFormValue('insured'); // setInsuredLen(insuredResult.length);

    setInsuredList(insuredResult);
  };

  const dealChildrenConf = i => {
    if (!(Array.isArray(children) && children.length)) {
      return [null, []];
    }

    const formKeyList = [];
    const result = children.map(item => {
      const modifiedFormkey = item.formKey.replace('.', `[${i}].`);
      formKeyList.push(modifiedFormkey);
      return _objectSpread(_objectSpread({}, item), {}, {
        formKey: modifiedFormkey
      });
    });
    return [result, formKeyList];
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "insured-list"
  }, Array.isArray(insuredList) && insuredList.map((item, i) => {
    const [childrenResult, formKeyList] = dealChildrenConf(i);
    return /*#__PURE__*/React.createElement(InsuredItem, {
      info: item,
      insuredIndex: i,
      key: item.customId,
      onDeleteItem: onDeleteInsuredItem,
      onSaveItem: () => onSaveInsuredItem(i),
      Render: Render,
      formKeyList: formKeyList,
      form: form
    }, childrenResult);
  }), !(Array.isArray(insuredList) && insuredList.length >= maxInsuredCount) && /*#__PURE__*/React.createElement("div", {
    className: "insured-add",
    onClick: onAddInsuredItem
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "add"
  })), /*#__PURE__*/React.createElement("span", null, buttonText)));
};

export default InsuredWithPlanSelect;